import React, { useEffect } from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilCursor,
  cilSpeedometer,
  cilUser,
  cilGamepad,
  cilUserPlus,
  cilControl,
  cilSettings,
  cilCalendarCheck,
  cilThumbUp,
  cibWhatsapp,
  cilListRich,
  cilVideo,
  cilCreditCard,
  cilTransfer,
  cilLink,
  cilInfo,
  cilLifeRing,
  cilCloudDownload,
  cilCloudUpload,
  cilDoor,
  cilChartLine,
  cilDollar,
  cilHandshake,
  cilPeople,
  cilEnvelopeClosed,
  cilGift,
  cilHeart,
  cilStar,
  cilCheckAlt,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'
const handleClick = (event) => {
  window.Produktly.openChangelog({ id: 240 })
  event.preventDefault()
  // Add any additional logic you need here
}
const analyticsSubMenu = [
  {
    component: CNavItem,
    name: 'Members',
    to: '/member-analytics',
  },
  {
    component: CNavItem,
    name: 'Players',
    to: '/player-analytics',
  },
  {
    component: CNavItem,
    name: 'Game',
    to: '/game-analytics',
  },
  {
    component: CNavItem,
    name: 'Game Charts',
    to: '/game-charts',
  },
  {
    component: CNavItem,
    name: 'Game Bars',
    to: '/game-bars',
  },
  {
    component: CNavItem,
    name: 'Branding Log',
    to: '/branding-log',
  },
  {
    component: CNavItem,
    name: 'Sponsor Log',
    to: '/sponsor-logs',
  },
]
const analyticsSubMenuMobile = analyticsSubMenu.map((item) => ({
  ...item,
  to: `${item.to}?device_type=mobile`,
}))

const analyticsSubMenuWeb = analyticsSubMenu.map((item) => ({
  ...item,
  to: `${item.to}?device_type=web`,
}))
const _nav = [
  // {
  //   component: CNavItem,
  //   name: `Get Started`,
  //   to: '/get-started',
  //   icon: <CIcon icon={cilInfo} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: 'Home',
    to: '/game-home',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Game Setup',
    to: '/game-setup',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Game Entry',
    to: '/game-entry',
    icon: <CIcon icon={cilDoor} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Approvals',
    to: '/approvals',
    icon: <CIcon icon={cilCheckAlt} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Point System',
    to: '/point-system',
    icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Pricing Plan',
    to: '/pricing-plan',
    icon: <CIcon icon={cilDollar} customClassName="nav-icon" />,
  },

  {
    component: CNavGroup,
    name: 'Players',
    to: '/',
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Players List',
        to: '/players',
      },
      // {
      //   component: CNavItem,
      //   name: 'Player Availability ',
      //   to: '/availabilities',
      // },
      {
        component: CNavItem,
        name: 'Player Profile ',
        to: '/players-profile',
      },
      {
        component: CNavItem,
        name: 'Player Stats ',
        to: '/players-stats',
      },
      {
        component: CNavItem,
        name: 'Player Sponsors',
        to: '/player-sponsors',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Fixtures',
    to: '/',
    icon: <CIcon icon={cilGamepad} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Create Fixtures',
        to: '/create-fixtures',
      },
      {
        component: CNavItem,
        name: 'Manage Scores',
        to: '/manage-scores',
      },
      {
        component: CNavItem,
        name: 'Completed Fixtures',
        to: '/completed-fixtures',
      },
      {
        component: CNavItem,
        name: 'Fixture Setting',
        to: '/fixture-setting',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Members',
    to: '/',
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Members List',
        to: '/members',
      },
      {
        component: CNavItem,
        name: 'Manage Members',
        to: '/manage-members',
      },
      // {
      //   component: CNavItem,
      //   name: 'Verify Members',
      //   to: '/verify-as-player',
      // },
      {
        component: CNavItem,
        name: 'Fantasy Leaderboard',
        to: '/fantasy-leaderboard',
      },
      // {
      //   component: CNavItem,
      //   name: 'Game Codes',
      //   to: '/game-codes',
      // },
      // {
      //   component: CNavItem,
      //   name: 'Member Invites',
      //   to: '/member-invites',
      // },
      // {
      //   component: CNavGroup,
      //   name: 'Verifications',
      //   to: '/',
      //   items: [
      //     {
      //       component: CNavItem,
      //       name: 'Paid Members',
      //       to: '/paid-members',
      //     },
      //   ],
      // },
    ],
  },
  {
    component: CNavItem,
    name: 'Partners & Promotions',
    to: '/sponsor-directory',
    icon: <CIcon icon={cilHandshake} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: 'Community',
    id: 'community-management-group', // Add unique ID
    to: '/community-purchase',
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Posts Manager',
        to: '/community-manager',
      },
      {
        component: CNavItem,
        name: 'Admin Posts',
        to: '/admin-posts',
      },
      {
        component: CNavItem,
        name: 'Round Winner',
        to: '/community-round-winner',
      },
      {
        component: CNavItem,
        name: 'Round Top Teams',
        to: '/community-top-teams',
      },
      {
        component: CNavItem,
        name: 'Player of the Round',
        to: '/community-player-of-the-round',
      },
      {
        component: CNavItem,
        name: 'Round Top Players',
        to: '/community-top-players',
      },
      {
        component: CNavItem,
        name: 'Ranking Updates',
        to: '/community-ranking-updates',
      },
      {
        component: CNavItem,
        name: 'Winner',
        to: '/community-winner',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Email Alerts',
    id: 'emaila-alerts-group', // Add unique ID
    to: '/email-purchase',
    icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
    items: [
      // {
      //   component: CNavItem,
      //   name: 'Purchase',
      //   to: '/purchase-email-alerts',
      // },
      {
        component: CNavItem,
        name: 'Send',
        to: '/send-email-alerts',
      },
      {
        component: CNavItem,
        name: 'Track',
        to: '/track-email-alerts',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Controls',
    to: '/',
    icon: <CIcon icon={cilControl} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Powers',
        to: '/power-control',
      },
      {
        component: CNavItem,
        name: 'Branding',
        to: '/branding',
      },
      {
        component: CNavItem,
        name: 'Prizes',
        to: '/prizes',
      },
      {
        component: CNavItem,
        name: 'Notifications',
        to: '/game-notifications',
      },
      {
        component: CNavItem,
        name: 'Articles',
        to: '/articles',
      },
      {
        component: CNavItem,
        name: 'Team Alerts',
        to: '/team-alerts',
      },
      {
        component: CNavItem,
        name: 'Bonus Points',
        to: '/bonus-points',
      },
      {
        component: CNavItem,
        name: 'Fantasy Values',
        to: '/fantasy-values',
      },
      {
        component: CNavItem,
        name: 'Trades Used',
        to: '/trades-used',
      },
      {
        component: CNavItem,
        name: 'Trades Log',
        to: '/trades-log',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Imports',
    to: '/',
    icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Fixtures',
        to: '/fixture-import',
      },
      {
        component: CNavItem,
        name: 'Players',
        to: '/player-import',
      },
      // {
      //   component: CNavItem,
      //   name: 'External Players',
      //   to: '/external-player-import',
      // },
      {
        component: CNavItem,
        name: 'Rounds',
        to: '/round-import',
      },
      {
        component: CNavItem,
        name: 'Squads',
        to: '/squad-import',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Analytics',
    to: '/',
    icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
    items: [
      {
        component: CNavGroup,
        name: 'Mobile',
        items: analyticsSubMenuMobile, // ✅ correct
      },
      {
        component: CNavGroup,
        name: 'Web',
        items: analyticsSubMenuWeb, // ✅ correct
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Downloads',
    to: '/downloads',
    icon: <CIcon icon={cilCloudDownload} customClassName="nav-icon" />,
  },

  // {
  //   component: CNavGroup,
  //   name: 'Analytics',
  //   to: '/',
  //   icon: <CIcon icon={cilElevator} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'danger-gradient',
  //     text: 'PRO',
  //   },
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Members',
  //       to: '/',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Overall',
  //       to: '/',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Players',
  //       to: '/',
  //     },
  //   ],
  // },
  {
    component: CNavTitle,
    name: 'Pro Add-Ons',
  },

  {
    component: CNavGroup,
    name: 'Bonus Cards',
    to: '/',
    icon: <CIcon icon={cilGift} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate',
        to: '/activate-bonus-card',
      },
      {
        component: CNavItem,
        name: 'Manage Bonus Cards',
        to: '/manage-bonus-cards',
      },
    ],
  },
  // {
  //   component: CNavGroup,
  //   name: 'Bracket Battle',
  //   to: '/',
  //   icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Activate',
  //       to: '/activate-bracket-battle',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Bracket Settings ',
  //       to: '/bracket-battle',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Bracket Rounds',
  //       to: '/bracket-round',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Round Points',
  //       to: '/bracket-battle/points',
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Head-2-Head',
  //   to: '/',
  //   icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Activate',
  //       to: '/activate-head-2-head',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'H2H Settings',
  //       to: '/h2h-settings',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'H2H Manage',
  //       to: '/h2h-manage',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'H2H Playoffs',
  //       to: '/h2h-play-off',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'H2H Leaderboard',
  //       to: '/h2h-leaderboard',
  //     },
  //   ],
  // },

  {
    component: CNavGroup,
    name: 'Pulse',
    to: '/',
    icon: <CIcon icon={cilHeart} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Settings',
        to: '/pulse-settings',
      },
      {
        component: CNavItem,
        name: 'Fantasy Pulse',
        to: '/pulse-listing/fantasy',
      },
      {
        component: CNavItem,
        name: 'Batting Pulse',
        to: '/pulse-listing/batting',
      },
      {
        component: CNavItem,
        name: 'Bowling Pulse',
        to: '/pulse-listing/bowling',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Team of the Round',
    to: '/',
    icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate TOTR',
        to: '/activate-team-of-the-round',
      },
      {
        component: CNavItem,
        name: 'Manage TOTR',
        to: '/manage-team-of-the-round',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Votes',
    to: '/fixture-votes',
    icon: <CIcon icon={cilCheckAlt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate Votes',
        to: '/activate-fixture-voting',
      },
      {
        component: CNavItem,
        name: 'Fixture Votes',
        to: '/fixture-voting',
      },
      {
        component: CNavItem,
        name: 'Team Votes',
        to: '/team-fixture-voting',
      },
      {
        component: CNavItem,
        name: 'Total Votes',
        to: '/total-voting',
      },
    ],
  },
  // {
  //   component: CNavTitle,
  //   name: 'Billings',
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Revenue',
  //   id: 'pricing-group',
  //   to: '/game-pass',
  //   icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Game Pass',
  //       to: '/game-pass',
  //     },

  //     {
  //       component: CNavItem,
  //       name: 'Payments',
  //       to: '/game-payments',
  //     },
  //   ],
  // },
  {
    component: CNavTitle,
    name: 'Links',
  },
  {
    component: CNavItem,
    name: `What's New`,
    to: '#',
    icon: <CIcon icon={cilListRich} customClassName="nav-icon" />,
    onClick: handleClick,
  },
  {
    component: CNavItem,
    name: 'Admin Community',
    to: 'https://chat.whatsapp.com/Hlp4McKF83vJ9mlqyXDmvb',
    icon: <CIcon icon={cibWhatsapp} customClassName="nav-icon" />,
  },

  {
    component: CNavItem,
    name: 'Admin Help Tours',
    to: 'https://share.layerpath.com/playlist/clyd0i2b5000cjo0c78apwfkv',
    icon: <CIcon icon={cilVideo} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Help Center',
    to: 'https://myclubtap.tawk.help/',
    icon: <CIcon icon={cilLifeRing} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Book Intro Session',
    to: 'https://calendly.com/vickyatmyclubtap/myclubtapintroforgameadminsin30mins?back=1&month=2023-08',
    icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
  },
  // {
  //   component: CNavItem,
  //   name: 'Community',
  //   to: '/',
  //   icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  // },
  // {
  //   component: CNavItem,
  //   name: 'Roadmap/Features',
  //   to: '/',
  //   icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: 'Share Feedback',
    to: 'https://testimonials.myclubtap.com/',
    icon: <CIcon icon={cilThumbUp} customClassName="nav-icon" />,
  },

  // {
  //   component: CNavGroup,
  //   name: 'Forms',
  //   icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Form Control',
  //       to: '/forms/form-control',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Select',
  //       to: '/forms/select',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Multi Select',
  //       to: '/forms/multi-select',
  //       badge: {
  //         color: 'danger-gradient',
  //         text: 'PRO',
  //       },
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Checks & Radios',
  //       to: '/forms/checks-radios',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Range',
  //       to: '/forms/range',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Input Group',
  //       to: '/forms/input-group',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Floating Labels',
  //       to: '/forms/floating-labels',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Date Picker',
  //       to: '/forms/date-picker',
  //       badge: {
  //         color: 'danger-gradient',
  //         text: 'PRO',
  //       },
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Date Range Picker',
  //       to: '/forms/date-range-picker',
  //       badge: {
  //         color: 'danger-gradient',
  //         text: 'PRO',
  //       },
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Time Picker',
  //       to: '/forms/time-picker',
  //       badge: {
  //         color: 'danger-gradient',
  //         text: 'PRO',
  //       },
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Layout',
  //       to: '/forms/layout',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Validation',
  //       to: '/forms/validation',
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Icons',
  //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'CoreUI Free',
  //       to: '/icons/coreui-icons',
  //       badge: {
  //         color: 'success-gradient',
  //         text: 'FREE',
  //       },
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'CoreUI Flags',
  //       to: '/icons/flags',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'CoreUI Brands',
  //       to: '/icons/brands',
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Notifications',
  //   icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Alerts',
  //       to: '/notifications/alerts',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Badges',
  //       to: '/notifications/badges',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Modal',
  //       to: '/notifications/modals',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Toasts',
  //       to: '/notifications/toasts',
  //     },
  //   ],
  // },
  // {
  //   component: CNavItem,
  //   name: 'Widgets',
  //   to: '/widgets',
  //   icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'info-gradient',
  //     text: 'NEW',
  //   },
  // },
  // {
  //   component: CNavItem,
  //   name: 'Smart Table',
  //   icon: <CIcon icon={cilGrid} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'danger-gradient',
  //     text: 'PRO',
  //   },
  //   to: '/smart-table',
  // },
  // {
  //   component: CNavTitle,
  //   name: 'Plugins',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Calendar',
  //   icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'danger-gradient',
  //     text: 'PRO',
  //   },
  //   to: '/plugins/calendar',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Charts',
  //   icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
  //   to: '/plugins/charts',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Google Maps',
  //   icon: <CIcon icon={cilMap} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'danger-gradient',
  //     text: 'PRO',
  //   },
  //   to: '/plugins/google-maps',
  // },
  // {
  //   component: CNavTitle,
  //   name: 'Extras',
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Pages',
  //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Login',
  //       to: '/login',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Register',
  //       to: '/register',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Error 404',
  //       to: '/404',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Error 500',
  //       to: '/500',
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Apps',
  //   icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavGroup,
  //       name: 'Invoicing',
  //       icon: <CIcon icon={cilSpreadsheet} customClassName="nav-icon" />,
  //       to: '/apps/invoicing',
  //       items: [
  //         {
  //           component: CNavItem,
  //           name: 'Invoice',
  //           badge: {
  //             color: 'danger-gradient',
  //             text: 'PRO',
  //           },
  //           to: '/apps/invoicing/invoice',
  //         },
  //       ],
  //     },
  //     {
  //       component: CNavGroup,
  //       name: 'Email',
  //       to: '/apps/email',
  //       icon: <CIcon icon={cilEnvelopeOpen} customClassName="nav-icon" />,
  //       items: [
  //         {
  //           component: CNavItem,
  //           name: 'Inbox',
  //           badge: {
  //             color: 'danger-gradient',
  //             text: 'PRO',
  //           },
  //           to: '/apps/email/inbox',
  //         },
  //         {
  //           component: CNavItem,
  //           name: 'Message',
  //           badge: {
  //             color: 'danger-gradient',
  //             text: 'PRO',
  //           },
  //           to: '/apps/email/message',
  //         },
  //         {
  //           component: CNavItem,
  //           name: 'Compose',
  //           badge: {
  //             color: 'danger-gradient',
  //             text: 'PRO',
  //           },
  //           to: '/apps/email/compose',
  //         },
  //       ],
  //     },
  //   ],
  // },
]

export default _nav
